module.exports = new __parcel__URL__("dice.cf49713f.mp3").toString();